module.exports = __webpack_public_path__ + "static/Doris-ddabaef6eaa628c706b0f1c908ea0c7c.jpg";